module.exports = __webpack_public_path__ + "bba61ae2827ac5165e3825709922763e.mp4";